import { Box, Heading, Text, Image,HStack, Flex, SimpleGrid } from '@chakra-ui/react';
import PublicLayout from "./Layouts/PublicLayout"
import CookiePolicy from "../../Components/CookiePolicy"

const B2CCookiePolicy = () => (
  <PublicLayout>
      <Box p={4}>
<CookiePolicy />
      </Box>
  </PublicLayout>
);

export default B2CCookiePolicy;